import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "revico-community-talk-post-media" }
const _hoisted_2 = { class: "revico-community-talk-post-media-wrapper" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["accept", "name", "disabled"]
const _hoisted_5 = {
  key: 0,
  class: "revico-community-talk-post-media-canceling"
}
const _hoisted_6 = { class: "revico-community-talk-post-media-description" }
const _hoisted_7 = { class: "revico-community-talk-post-media-description--item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("li", { class: "revico-community-talk-post-media-description--item" }, "アップロードできる画像拡張子は、png/jpg/jpeg/gif(静止画)です。", -1 /* HOISTED */)
const _hoisted_9 = { class: "revico-community-talk-post-media-description--item" }
const _hoisted_10 = { class: "revico-community-talk-post-media-description" }
const _hoisted_11 = { class: "revico-community-talk-post-media-description--item" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("li", { class: "revico-community-talk-post-media-description--item" }, "アップロードできる動画拡張子は、mp4/movです。", -1 /* HOISTED */)
const _hoisted_13 = { class: "revico-community-talk-post-media-description--item" }
const _hoisted_14 = {
  key: 1,
  class: "revico-community-talk-post-media-preview"
}
const _hoisted_15 = { class: "revico-community-talk-post-media-preview-media-wrapper" }
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 0,
  class: "revico-community-talk-post-media-preview--thumbnail-play-button"
}
const _hoisted_18 = {
  key: 2,
  class: "revico-community-talk-post-media-error-message"
}
const _hoisted_19 = {
  key: 3,
  class: "revico-community-talk-post-media-error-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["ApiPostLoadMaster"], { status: $setup.status }, {
      beforeRequest: _withCtx(() => [
        _createVNode($setup["CustomLabel"], {
          class: "revico-community-talk-post-media--label",
          text: "写真・動画アップロード",
          disabled: $props.disabled
        }, null, 8 /* PROPS */, ["disabled"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: "revico-community-talk-post-media--input-button",
            disabled: $props.disabled || $setup.isProcessing,
            onClick: $setup.onClickInputFileButton
          }, "ファイルを選択", 8 /* PROPS */, _hoisted_3),
          _createElementVNode("input", {
            ref: "inputElement",
            onChange: $setup.upload,
            type: "file",
            accept: $setup.MediaUtil.validExtensions.join(),
            name: $setup.name,
            disabled: $props.disabled || $setup.isProcessing,
            class: "revico-community-talk-post-media--input",
            multiple: ""
          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_4),
          ($setup.isCanceledUpload && $setup.isProcessing)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, "アップロードをキャンセルしています…"))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" 画像・動画投稿時の注意文言 "),
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", _hoisted_7, " 画像を複数枚アップロードする場合は、アップロードする画像をまとめて選択してください。(上限" + _toDisplayString($setup.mediaController.maxImageCount) + "枚) ", 1 /* TEXT */),
            _hoisted_8,
            _createElementVNode("li", _hoisted_9, "画像サイズの上限は、1枚あたり" + _toDisplayString($setup.MediaUtil.maxFileSize.image / 1024 / 1024) + "MBです。", 1 /* TEXT */)
          ]),
          _createElementVNode("ul", _hoisted_10, [
            _createElementVNode("li", _hoisted_11, "動画は" + _toDisplayString($setup.mediaController.maxMovieCount) + "つのみアップロードできます。", 1 /* TEXT */),
            _hoisted_12,
            _createElementVNode("li", _hoisted_13, " 動画サイズおよび再生時間の上限は、それぞれ" + _toDisplayString($setup.MediaUtil.maxFileSize.movie / 1024 / 1024) + "MB、" + _toDisplayString($setup.MediaUtil.maxMoviePlayTime) + "秒です。 ", 1 /* TEXT */)
          ]),
          _createCommentVNode(" 画像・動画のプレビュー "),
          ($setup.state.postMediaViewModels.length > 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.postMediaViewModels, (viewModel, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: _normalizeClass($setup.previewMediaClass(viewModel))
                    }, [
                      _createElementVNode("img", {
                        src: viewModel.mediaUrl,
                        onError: $setup.detachMedia
                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_16),
                      _createCommentVNode(" 動画サムネイル用再生ボタン "),
                      (viewModel.type === 'Movie')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17))
                        : _createCommentVNode("v-if", true)
                    ], 2 /* CLASS */))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _createCommentVNode(" プレビュー解除ボタン "),
                _createElementVNode("button", {
                  class: "revico-community-talk-post-media-preview--detach-button",
                  type: "button",
                  onClick: $setup.detachMedia
                }, "選択を解除")
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" APIエラーメッセージ "),
          ($setup.errorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString($setup.errorMessage), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" 親コンポーネントからのAPIエラーメッセージ "),
          ($setup.parentErrorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString($setup.parentErrorMessage), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      loading: _withCtx(() => [
        _createCommentVNode(" 画像・動画投稿キャンセルボタン "),
        ($setup.isProcessing)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "revico-community-talk-post-media--cancel-button",
              onClick: $setup.cancelUpload
            }, "写真・動画の投稿をキャンセル"))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["status"])
  ]))
}